import { EConsumerScanStatus, ERewardActivityStatus, EScanStatus } from 'src/types'

export const getColorOrNameByScanStatus = (mode: 'color' | 'text', status: EScanStatus) => {
  switch (status) {
    case EScanStatus.NEW:
      return mode === 'color' ? '#00AEEF' : 'New'
    case EScanStatus.APPROVED:
      return mode === 'color' ? '#28A745' : 'Approved'
    case EScanStatus.NOT_APPROVED:
      return mode === 'color' ? '#E57373' : 'Not Approved'
    case EScanStatus.ON_CHAIN:
      return mode === 'color' ? '#6f3cce' : 'On-Chain'
    default:
      return mode === 'color' ? '#6C757D' : 'Unknown'
  }
}

export const getColorOrNameByConsumerScanStatus = (
  mode: 'color' | 'text',
  status: ERewardActivityStatus | EConsumerScanStatus,
) => {
  switch (status) {
    case ERewardActivityStatus.PENDING:
      return mode === 'color' ? '#ff9500' : 'Pending'
    case ERewardActivityStatus.APPROVED:
      return mode === 'color' ? '#28A745' : 'Approved'
    case ERewardActivityStatus.DECLINED:
      return mode === 'color' ? '#E57373' : 'Declined'
    default:
      return mode === 'color' ? '#6C757D' : 'Unknown'
  }
}
